import { userService } from '../services'

export const users = {
    namespaced: true,
    state: {
        all: {
            status: false
        },
        profile: {},
        feedback: {},
        
    },
    actions: {
        async getProfile({ commit }) {
            commit('PROFILE_REQUEST')
            await userService.getProfile()
                .then( profile => commit('PROFILE_FETCH_SUCCESS', profile),
                error => commit('PROFILE_FETCH_FAILURE',{error}))
        },

     setProfile({commit }, profile) {
        commit('PROFILE_UPDATE_REQUEST',  profile )

        return new Promise((resolve, reject) => {
            userService.setProfile(profile)
            .then(
                profile => {
                   
                     commit('PROFILE_UPDATE_SUCCESS', profile)
                     resolve('success');
                },
                error => {
                    let errors=error.errors
                    commit('PROFILE_UPDATE_FAILURE', errors)
                    reject(new Error("fail"));
                }
            )
          })
        
    },

    getFeedbackStatus({commit}){
        userService.getFeedbackStatus()
            .then(payload =>{
                 commit('FEEDBACK_FETCH_SUCCESS', payload)
            },
            error =>{
                commit('FEEDBACK_FETCH_FAILURE', error)
            }
            )
    },
    makePayment({dispatch,commit}){
        return new Promise((resolve, reject) => {
            userService.makePayment()
            .then(
                response => {

                    window.location.replace(response.url);
                    commit('PAYMENT_SUCCESS', response)
                    //resolve('success');
                },
                error => {
                    commit('PAYMENT_FAILURE',{error})
                    //reject(new Error("fail"));
                }
            )
          })
    },
   
},
    mutations: {
        PROFILE_REQUEST(state) {
            state.all = { loading: true }
        },
        ALL_SUCCESS(state, users) {
            state.all = { items: users }
        },
        PROFILE_FETCH_SUCCESS(state, profile) {
            //console.log(profile)
            state.profile=profile
        },
        PROFILE_FETCH_FAILURE(state, error) {
            //console.log(error)
            state.all = { error }
        },
        PROFILE_UPDATE_REQUEST(state, profile) {
            state.profile = profile
        },
        PROFILE_UPDATE_SUCCESS(state, profile) {
            state.all ={errors: null,
            status: true
            }
            
            state.profile = profile
        },
        PROFILE_UPDATE_FAILURE(state, errors) {
            state.all ={ errors,
            status: false }
        },
        FEEDBACK_FETCH_SUCCESS(state, payload){
            state.feedback = payload
        },
        FEEDBACK_FETCH_FAILURE(state, error){
            state.feedback = {error: error}
        },
        PAYMENT_SUCCESS(state, data) {
            state.payment_done=true;   
        
        },
        PAYMENT_FAILURE(state, error) {
            state.payment_done=false;
            state.all = { error }
            
        },
    }
}